export const commonWillUnmount = () => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return (target: any) => {
		const componentWillUnmount = target.prototype.componentWillUnmount;

		target.prototype.componentWillUnmount = function() {
			if (!!this?.props?.uiStore) {
				this?.props?.uiStore.resetStatus();
			}

			if (typeof componentWillUnmount === 'function') {
				componentWillUnmount.call(this);
			}
		};

		return target;
	};
};
